/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : SearchFilter.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       :
 *
 * @Date         : Oct 10, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : Oct 10, 2019
 * Description   : Added Version history. ASDS-1478 - Grid level resposnive changes and UI issue fixes
 *
 * By            : SandeepRaja
 * On            : Oct 31, 2019
 * Description   : ASDS-1672: Empty Product Search UI & Integration
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes.
 *
 * By            : H422336
 * On            : Sep 07, 2020
 * Description   : ASDS-2748 UI Enhancements Phase-II
 *
*******************************************************************************/
import React from 'react';
import { connect } from 'react-redux';
import {  Input } from '@scuf/common';
import ProductListingActions from '../redux/actions/product-listing-actions';
import { SelectCategoryValue } from './';
import CheckoutConstants, {CheckoutUILabels} from '../constants/checkout-constants';

interface SearchFilterState {
    searchValue: string,
    hasInvalidPattern: boolean,
}

interface SearchFilterProps {
    getProductListing: Function,
    selectedCategory: SelectCategoryValue,
    setSelectedCategory: Function,
}

/**
 * @author ASDS Team
 * @description Search Filter button.
 */
class SearchFilter extends React.Component<SearchFilterProps | any, SearchFilterState> {

    state = {
        searchValue: this.props.searchTerm,
        hasInvalidPattern: false,
    };

    validSearchPattern = /^[A-Za-z0-9\s.,-_\\\/&]*$/i;
    searchTextLength = 50;
    searchTermRequest:NodeJS.Timeout;

    constructor(props) {
        super(props);
        this.validateAndSetSearchValue = this.validateAndSetSearchValue.bind(this);
        this.requestForSearchTerm = this.requestForSearchTerm.bind(this);
    }
    requestForSearchTerm() {
        if (this.state.searchValue && this.state.searchValue.length >= 3) {
            this.props.getProductListing(this.state.searchValue);
        } else if (!this.state.searchValue) {
            this.props.setSelectedCategory(this.props.selectedCategory);
        }
    }

    validateAndSetSearchValue(searchValue="") {
        const isLengthBeyondBoundary = searchValue.length <= this.searchTextLength;
        if(!isLengthBeyondBoundary) {
            searchValue = searchValue.substr(0,this.searchTextLength);
        }
        // search values should have valid pattern
        const hasValidPattern = this.validSearchPattern.test(searchValue);
        if(!hasValidPattern) {
            this.setState({
                hasInvalidPattern: true,
                searchValue,
            });
        } else {
            if(this.state.hasInvalidPattern) {
                this.setState({
                    hasInvalidPattern: false,
                }, () => this.setSearchValue(searchValue));
            } else {
                this.setSearchValue(searchValue);
            }
        }
    }

    setSearchValue(searchValue) {
        this.setState({
            searchValue
        }, () => {
            if(this.searchTermRequest) {
                clearTimeout(this.searchTermRequest)
            }
            this.searchTermRequest = setTimeout(this.requestForSearchTerm,CheckoutConstants.IDLE_TIME_FOR_SEARCH_REQUEST);
        });
    }

    render() {
        return (
                <Input
                    className={`input-example search-filter ${this.state.hasInvalidPattern ? 'input-error': ''}`}
                    placeholder="Search by products"
                    search={true}
                    error={this.state.hasInvalidPattern ? CheckoutUILabels.SEARCH_TERM_INVALID_PATTER :''}
                    value={this.state.searchValue}
                    onChange={this.validateAndSetSearchValue}
                    disabled={this.props.isProductsFetching}
                    autoFocus
                />
        );
    }
}

function mapStateToProps(state) {
    const { selectedCategory } = state.categories.payload;
    const { productListing = {} } = state.products.payload;
    return {
        selectedCategory,
        isProductsFetching: productListing.isFetching,
        searchTerm: productListing.data ? productListing.data.searchTerm : ''
    };
}

const mapDispatchToProps = {
    getProductListing: ProductListingActions.searchProducts,
    setSelectedCategory: ProductListingActions.setSelectedCategory,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilter);